import DropDownViewModel from "../ViewModels/DropDownViewModel";

const monitoringReportDirectionOptionsDropdown: DropDownViewModel[] = [
    { label: "Select Start/End Time", id: "0" },
    { label: "Use All Times", id: "1" },
    { label: "Use Peak Period", id: "2" }
]

export default monitoringReportDirectionOptionsDropdown;